import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyErrorBoundary = lazy(() => import('./ErrorBoundary.tsx'));

const ErrorBoundary = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={<PageLoading />}>
    <LazyErrorBoundary {...props} />
  </Suspense>
);

export default ErrorBoundary;
